import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    q: 'How quickly can you deploy workers?',
    a: 'We can typically deploy within 24–48 hours for standard requirements. For urgent requests (same-day deployment), please call us directly and we will prioritize your need.',
  },
  {
    q: 'Do you handle PF, ESI and other compliances?',
    a: 'Yes, absolutely. SSM Services manages all statutory compliances including PF, ESI, Gratuity, Professional Tax, and labour contract registrations. You get zero legal liability.',
  },
  {
    q: 'What areas do you serve?',
    a: 'We primarily serve Chakan MIDC, Talegaon MIDC, Bhosari MIDC, and surrounding industrial areas in Pune district, Maharashtra. For other locations, please contact us to discuss.',
  },
  {
    q: 'Can you provide housekeeping for small offices too?',
    a: 'Yes, our housekeeping services cater to factories, warehouses, corporate offices, and retail spaces — large or small. We customize team size and visit frequency to your needs.',
  },
  {
    q: 'How are your workers trained?',
    a: 'All workers undergo skills training, safety induction (PPE usage, fire safety, machine handling), background verification, and periodic performance evaluations before deployment.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="faq section-light" id="faq">
      <div className="container">
        <div className="faq-header">
          <span className="section-label">Common Questions</span>
          <h2 className="section-title">Frequently Asked <span>Questions</span></h2>
        </div>
        <div className="faq-list">
          {faqs.map((f, i) => (
            <div className="faq-item" key={i}>
              <button
                className={`faq-q ${openIndex === i ? 'open' : ''}`}
                onClick={() => toggle(i)}
              >
                {f.q}
                <span className="faq-arrow">{openIndex === i ? '−' : '+'}</span>
              </button>
              <div className={`faq-a ${openIndex === i ? 'open' : ''}`}>
                <p>{f.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
